/**
 * pixi-particles — zones/RandomZone.ts
 * Ported from Phaser.GameObjects.Particles.Zones.RandomZone
 */
import { IZoneSource } from './Shapes';
import { AnyParticle } from '../EmitterOp';

export class RandomZone
{
    type = 'random';
    total = -1;

    constructor (public source: IZoneSource) {}

    getPoint (particle: AnyParticle): void
    {
        this.source.getRandomPoint!(particle);
    }
}

export default RandomZone;
